:host {
  --primary-standard: var(--secondary-hard, #435171);
  //--jump-button-background-hover: var(--secondary-hard, #435171);
  --jump-button-background-hover: red;
  --jump-filter-close-btn-bg: white;
  --bg-drawer: var(--bg-drawer, #fff);
  --header-height: var(--header-height, 80px);
  --drawer-width: var(--drawer-width, 240px);
  --overlay-bg-color: var(--overlay-bg-color, rgba(0, 0, 0, 0.35));

  h3 {
    margin: 0;
  }
}

@mixin fade-in-out($duration: 0.3s, $ease: ease-in-out) {
  opacity: 0;
  transition: opacity $duration $ease;

  &.filtersDrawer__overlay--active {
    opacity: 1;
  }
}

.filtersDrawer__overlay {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--overlay-bg-color, rgba(0, 0, 0, 0.35));
  z-index: 1;
  width: 100vw;
  height: 100vh;
  display: none;

  &.filtersDrawer__overlay--active {
    display: block;
  }

  @include fade-in-out();
}

.filtersDrawer {
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  left: -100vw;
  top: 0;
  height: -webkit-fill-available;
  max-height: calc(100vh - var(--header-height));
  transition: 0.3s all ease-in-out;
  background-color: var(--bg-drawer, #fff);
  padding: 1rem;
  width: 100%;
  max-width: var(--drawer-width);
  box-shadow: 8px 0 15px 0 #00000026;
  z-index: 2;
  overflow: auto;

  &[aria-hidden="false"] {
    left: 0;
    right: 0;
    width: auto;
    transition: 0.3s all ease-in-out;

    .filtersDrawer__close {
      position: fixed;
      top: calc(var(--header-height) + 0rem);
      left: calc(var(--drawer-width) + 2rem);
      background-color: var(--jump-filter-close-btn-bg, white);
      padding: 0.5rem;
      box-shadow: 8px 0 15px 0 #00000026;
    }
  }

  @media (min-width: 768px) { //md breakpoint tailwind
    position: relative;
    left: 0;
    height: auto;
    max-width: initial;
    max-height: initial;
    box-shadow: none;
  }

  @media (max-width: 767px) {
    top: var(--header-height);
  }

  .filtersDrawer__header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
  }
}
